import { render, staticRenderFns } from "./partner-search.vue?vue&type=template&id=036941d2&scoped=true"
import script from "./partner-search.vue?vue&type=script&lang=js"
export * from "./partner-search.vue?vue&type=script&lang=js"
import style0 from "./partner-search.vue?vue&type=style&index=0&id=036941d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036941d2",
  null
  
)

export default component.exports